import React, {useEffect, useState} from 'react';
import './App.css';
import ColorGrid from "./ColorGrid";
import HexCube, {Cube, viewSettings} from "../builder/HexCube";
import {HEX} from "../types/colors";
import GetColor from './GetColor';
import AdjustCube from "./AdjustCube";
import Canvas from "../canvas/Canvas";
import {hexToRGBArray} from "../converters/colors";

function App() {
    const [hexcube, setHexcube] = useState<Cube>()
    const [hexinput, setHexinput] = useState<HEX>('#6C3082')
    const [hexcube_steps, setHexcube_steps] = useState<number>(32)
    const [hexcube_width, setHexcube_width] = useState<number>(8)
    const [hexcube_view, setHexcube_view] = useState<viewSettings>("global")

    console.log("top")

    // useEffect(() => {
    //     setHexcube(HexCube())
    // }, []);

    useEffect(() => {
        setHexcube(HexCube(hexcube_width, hexcube_steps, hexcube_view==="local"&&hexToRGBArray(hexinput)))
    }, [hexcube_steps, hexcube_width, hexcube_view, hexinput]);

    let handleHexinput = (input:HEX):void=>{
        setHexinput(input)
    }

    // note: html colors
    // https://www.w3schools.com/colors/colors_names.asp
    return (
        <div className="App">
            <h1>Color Cube</h1>
            <GetColor hexinput={hexinput} handleHexinput={handleHexinput}/>
            <Canvas grid={hexToRGBArray(hexinput)} />
            <AdjustCube
                width={hexcube_width} setWidth={setHexcube_width}
                step={hexcube_steps} setStep={setHexcube_steps}
                view={hexcube_view} setView={setHexcube_view}
            />
            {hexcube&&<ColorGrid color={hexinput} hexcube={hexcube}/>}
        </div>
    );
}

export default App;
